<app-navbar></app-navbar>
<div class="container-fluid mt-5">
    <div class="col-12 d-none d-lg-block d-xl-block">
        <h2>
            <img src="../../../assets/img/monitor.png" width="70" class="img-fluid" alt="Responsive image"> Productos Seleccionados:
        </h2>
        <hr>
        <div class="row">
            <div class="col-8" style="border-right: solid;border-width: 1px; border-color: rgb(151, 151, 151);">
               <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="text-center">Producto</th>
                            <th class="text-center"></th>
                            <th class="text-center">Presentación</th>
                            <th class="text-center"></th>
                            <th class="text-center">Color</th>
                            <th class="text-center">Cantidad</th>
                            <th class="text-center">Precio</th>
                            <th class="text-center">Total</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of lista; let i = index">
                            <td class="text-center"><img [src]="item.imagen" width="70" class="img-fluid" alt="Responsive image"></td>
                            <td class="text-center"><b>{{item.nombre}}</b></td>
                            <td class="text-center"><b>{{item.tamano}}</b></td>
                            <td class="text-center"><b>{{item.presentacion}}</b></td>
                            <td class="text-center"><b>{{item.color}}</b></td>
                            <td class="text-center">{{item.cantidad}}</td>
                            <td class="text-center">${{item.precio | number}}</td>
                            <td class="text-center"><b>${{item.total | number}}</b></td>
                            <td class="text-center">
                                <button class="btn btn-danger" (click)="deleteItem(i)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
               </div>
            </div>
            <div class="col-4 mt-1">
                <h4 class="text-center">Resumen de compra</h4>
                <hr>
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 text-left">
                            <h5>Subtotal:</h5>
                            <h5>Descuento:</h5>
                            <h5>Flete:</h5>
                            <h5>Descuento Distribuidor:</h5>
                            <br>
                            <h2>Total:</h2>
                        </div>
                        <div class="col-6 text-right">
                            <h5><b style="color: rgb(27, 8, 134);">${{subtotal | number}}</b></h5>
                            <h5><b>{{descto}}%</b></h5>
                            <h5><b>${{flete | number}}</b></h5>
                            <h5><b>${{descuento | number}}</b></h5>
                            <br>
                            <hr>
                            <h2><b style="color: rgb(172, 2, 2);">${{liquidacion | number}}</b></h2>
                        </div>
                    </div>
                    <hr>
                    <h4>Datos de envío y facturación:</h4>
                    <div *ngIf="usuario">
                        <input type="text" [value]="usuario.nombre" class="form-control" placeholder="Ingrese su nombre" autocomplete="off" >
                        <input type="text" [value]="usuario.cedula" class="form-control mt-2" placeholder="Ingrese su número de cédula" autocomplete="off">
                        <input type="text" [value]="usuario.telefono" class="form-control mt-2" placeholder="Ingrese su número de celular" autocomplete="off">
                        <input type="text" [value]="usuario.email" class="form-control mt-2" placeholder="Ingrese correo electrónico" autocomplete="off">
                    </div>
                    <div *ngIf="!usuario">
                        <input type="text" class="form-control" (change)="nombreCliente($event.target.value)" placeholder="Ingrese su nombre" autocomplete="off">
                        <input type="text" class="form-control mt-2" (change)="cedulaCliente($event.target.value)" placeholder="Ingrese su número de cédula" autocomplete="off">
                        <input type="text" class="form-control mt-2" (change)="telefonoCliente($event.target.value)" placeholder="Ingrese su número de celular" autocomplete="off">
                        <input type="text" class="form-control mt-2" (change)="emailCliente($event.target.value)" placeholder="Ingrese correo electrónico" autocomplete="off">
                    </div>
                    <input type="text" class="form-control mt-2" (change)="ciudadEnvio($event.target.value)" placeholder="Ingrese la ciudad de entrega" autocomplete="off">
                    <input type="text" class="form-control mt-2" (change)="direccionEnvio($event.target.value)" placeholder="Ingrese la dirección de entrega" autocomplete="off">
                    <button class="btn btn-primary btn-block continue mt-2" (click)="onClick()"><i class="fa fa-undo fa-lg"></i> Seguir Comprando</button>
                    <button class="btn btn-danger btn-block request" (click)="datosCliente()"><i class="fa fa-check fa-lg"></i> Enviar Pedido</button>
                    <br><br>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
        <h2>
            <img src="../../../assets/img/monitor.png" width="70" class="img-fluid" alt="Responsive image"> Productos Seleccionados:
        </h2>
        <hr>
        <div class="col-12" style="border-right: solid;border-width: 1px; border-color: rgb(151, 151, 151);">
            <table class="table table-responsive">
                <thead>
                    <tr>
                        <th class="text-center">Producto</th>
                        <th class="text-center"></th>
                        <th class="text-center">Presentación</th>
                        <th class="text-center">Color</th>
                        <th class="text-center">Cantidad</th>
                        <th class="text-center">Precio</th>
                        <th class="text-center">Total</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of lista; let i = index">
                        <td class="text-center"><img [src]="item.imagen" width="70" class="img-fluid" alt="Responsive image"></td>
                        <td class="text-center"><b>{{item.nombre}}</b></td>
                        <td class="text-center"><b>{{item.tamano}}</b></td>
                        <td class="text-center"><b>{{item.color}}</b></td>
                        <td class="text-center">{{item.cantidad}}</td>
                        <td class="text-center">${{item.precio | number}}</td>
                        <td class="text-center"><b>${{item.total | number}}</b></td>
                        <td class="text-center">
                            <button class="btn btn-danger" (click)="deleteItem(i)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr>
        <div class="col-12 mt-1">
            <h4 class="text-center">Resumen de compra</h4>
            <hr>
            <div class="col-12">
                <div class="row">
                    <div class="col-6 text-left">
                        <h5>Subtotal:</h5>
                        <h5>Flete:</h5>
                        <h5>Descuento Distribuidor:</h5>
                        <br>
                        <h2>Total:</h2>
                    </div>
                    <div class="col-6 text-right">
                        <h5><b style="color: rgb(27, 8, 134);">${{subtotal | number}}</b></h5>
                        <h5><b>${{flete | number}}</b></h5>
                        <h5><b>${{descuento | number}}</b></h5>
                        <br>
                        <hr>
                        <h2><b style="color: rgb(172, 2, 2);">${{liquidacion | number}}</b></h2>
                    </div>
                </div>
                <hr>
                <h4>Datos de envío y facturación:</h4>
                <div *ngIf="usuario">
                    <input type="text" [value]="usuario.nombre" class="form-control" placeholder="Ingrese su nombre" autocomplete="off" >
                    <input type="text" [value]="usuario.cedula" class="form-control mt-2" placeholder="Ingrese su número de cédula" autocomplete="off">
                    <input type="text" [value]="usuario.telefono" class="form-control mt-2" placeholder="Ingrese su número de celular" autocomplete="off">
                    <input type="text" [value]="usuario.email" class="form-control mt-2" placeholder="Ingrese correo electrónico" autocomplete="off">
                </div>
                <div *ngIf="!usuario">
                    <input type="text" class="form-control" (change)="nombreCliente($event.target.value)" placeholder="Ingrese su nombre" autocomplete="off">
                    <input type="text" class="form-control mt-2" (change)="cedulaCliente($event.target.value)" placeholder="Ingrese su número de cédula" autocomplete="off">
                    <input type="text" class="form-control mt-2" (change)="telefonoCliente($event.target.value)" placeholder="Ingrese su número de celular" autocomplete="off">
                    <input type="text" class="form-control mt-2" (change)="emailCliente($event.target.value)" placeholder="Ingrese correo electrónico" autocomplete="off">
                </div>
                <input type="text" class="form-control mt-2" (change)="ciudadEnvio($event.target.value)" placeholder="Ingrese la ciudad de entrega" autocomplete="off">
                <input type="text" class="form-control mt-2" (change)="direccionEnvio($event.target.value)" placeholder="Ingrese la dirección de entrega" autocomplete="off">
                <button class="btn btn-primary btn-block continue mt-2" (click)="onClick()"><i class="fa fa-undo fa-lg"></i> Seguir Comprando</button>
                <button class="btn btn-danger btn-block request" (click)="datosCliente()"><i class="fa fa-check fa-lg"></i> Enviar Pedido</button>
                <br>
                <br>
            </div>
        </div>
    </div>
</div>